declare var __PACKAGE_VERSION__: ''

if (typeof __PACKAGE_VERSION__ === 'undefined') {
  (<any>global).__PACKAGE_VERSION__ = 'dev'
}

export default {
  VERSION: __PACKAGE_VERSION__
}
